function getBannerType(daysToExpiry, status, date) {
  const colourOptions = {
    NINETY_DAYS: {
      colour: 'green',
      text: `Heads Up! Your Subscription is up for renewal on <b>${date}</b>.`,
      callToActionText: 'It\'s a way down the track but time flies when you\'re having fun, am I right? Reach out to your Account Manager to discuss renewal options.'
    },
    SIXTY_DAYS: {
      colour: 'green',
      text: `Heads Up! Your Subscription is up for renewal on <b>${date}</b>`,
      callToActionText: '60 days will fly past so ensure you\'re in contact with your Account Manager to discuss renewal'
    },
    THIRTY_DAYS: {
      colour: 'orange',
      text: 'Your Subscription is due for renewal soon.',
      callToActionText: `If not renewed by <b>${date}</b>, your workspace will have limited access to features.`
    },
    FOURTEEN_DAYS: {
      colour: 'red',
      text: 'Your Subscription will expire soon.',
      callToActionText: `If not renewed by <b>${date}</b>, your workspace will have limited access to features.`
    },
    SEVEN_DAYS: {
      colour: 'red',
      text: 'Your Subscription will expire very soon.',
      callToActionText: `If not renewed before <b>${date}</b>, your workspace will have limited access to features.`
    },
    EXPIRED: {
      colour: 'red',
      text: 'Your Subscription to Shootsta has expired.',
      callToActionText: 'Your workspace now has limited access to features.'
    }
  };

  if (daysToExpiry > 90) {
    return null;
  }
  if (daysToExpiry > 60) {
    return colourOptions.NINETY_DAYS;
  }
  if (daysToExpiry > 30) {
    return colourOptions.SIXTY_DAYS;
  }
  if (daysToExpiry > 14) {
    return colourOptions.THIRTY_DAYS;
  }
  if (daysToExpiry > 7) {
    return colourOptions.FOURTEEN_DAYS;
  }
  if (daysToExpiry !== null && daysToExpiry >= 0) {
    return colourOptions.SEVEN_DAYS;
  }
  if (daysToExpiry < 0 || status === 'EXPIRED') {
    return colourOptions.EXPIRED;
  }
  return null;
}

export default getBannerType;